import { Directive, ElementRef, input, InputSignal, inject, afterNextRender, Injector } from '@angular/core';
import { InteractivityService } from '../../services/interactivity-service';

@Directive({
  selector: '[tdWbFocusTrackerItem]',
  exportAs: 'tdWbFocusTrackerItem'
})
export class FocusTrackerItemDirective {

  readonly trackById: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'tdWbFocusTrackerItem' });

  private readonly interactivityService = inject(InteractivityService);
  private readonly injector = inject(Injector);
  private readonly elementRef = inject(ElementRef);

  focus(): void {
    const target = this.interactivityService.getFirstTabbableElement(this.elementRef.nativeElement);
    if (target !== undefined && target !== null) {
      afterNextRender(() => target.focus(),
        { injector: this.injector }
      );
    }
  }
}

